import { render, staticRenderFns } from "./AccountAmount.vue?vue&type=template&id=f893c5d8&scoped=true&"
import script from "./AccountAmount.vue?vue&type=script&lang=js&"
export * from "./AccountAmount.vue?vue&type=script&lang=js&"
import style0 from "./AccountAmount.vue?vue&type=style&index=0&id=f893c5d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f893c5d8",
  null
  
)

export default component.exports